import React from 'react'
import Link from 'gatsby-link'
import contents from "../contents.json";

const Header = () =>
  <div className="header">
    <div className="header-container">
      <Link to="/" className="header-home">Books, Accelerated</Link>
      <p className="description">Innovative Apps and books to learn faster and better.</p>

      <div className="header-links">
        {contents.map((item, i) => <Link to={item.path} activeClassName="active">{item.name}</Link>)}
        <Link to="/soon" activeClassName="active">Coming Soon</Link>
      </div>
    </div>
  </div>

export default Header;


// WEBPACK FOOTER //
// ./src/components/header.js